import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EMPLOYEE_AUTH_SERVICE_IMPL } from 'pm-src/services/employee-auth/i-employee-auth.service';
import { Router } from '@angular/router';
import { IonToasterService } from 'shared';

@Injectable()
export class PMHttpStatusInterceptor implements HttpInterceptor {
    private _toasterService: IonToasterService;

    get toasterService(): IonToasterService {
        if (this._toasterService === undefined) {
            this._toasterService = this._injector.get(IonToasterService);
        }
        return this._toasterService;
    }

    constructor(private _injector: Injector, private _router: Router) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((err) => {
                switch (err.status) {
                    case 401:
                        if (err.error === 'employee-logout-forced') {
                            this._router.navigate(['/employeelogin']);
                        }
                        if (
                            Object.prototype.toString.call(err.error) ===
                                '[object String]' &&
                            err.error?.includes('employee-passchange-forced')
                        ) {
                            const empID = err.error.substring(
                                err.error.lastIndexOf(':') + 1
                            );
                            this._router.navigate([
                                '/employeelogin/changepassword',
                                empID,
                            ]);
                            break;
                        }
                        this.removeCurrentEmployee();
                        break;
                    default:
                        this.toasterService.error(
                            err.error || err.message || err.statusText
                        );
                        break;
                }
                return throwError(err);
            })
        );
    }

    private removeCurrentEmployee(): void {
        setTimeout(() => {
            const employeeAuthService = this._injector.get(EMPLOYEE_AUTH_SERVICE_IMPL);
            employeeAuthService.removeCurrentEmployee();
        }, 0);
    }
}
